import { Reveal, Fade } from "react-awesome-reveal";

import mindMap from "../assets/images/png/mindMap.png";
import website from "../assets/images/png/website.png";
import data from "../assets/images/png/data.png";
import webIcons from "../assets/images/png/WebIcons.png";
import googleIcons from "../assets/images/png/GoogleAppIcons.png";

export const About = () => {
  return (
    <section id="service">
      <div className="py-5">
        <div style={{ fontWeight: "500" }}>
          <div className="h2 text-center mt-4 mb-5">
            <span className="border-bottom border-info border-3">
              About
              <br />
              fueri.
            </span>
          </div>
          <div className="container text-center text-md-start">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-4">
                <Reveal triggerOnce>
                  <p>
                    fueri（フエリ）ではGoogleのサービスを中心に、
                    <br />
                    作業の効率化を図ったシステム/ツールを開発しております。
                  </p>
                </Reveal>
              </div>
              <div className="col-md-4">
                <Fade triggerOnce direction="right">
                  <img
                    className="float-end"
                    src={mindMap}
                    alt="mindMap"
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                </Fade>
              </div>
            </div>
            <div className="row align-items-center justify-content-center">
              <div className="col-md-4 order-md-1">
                <Reveal triggerOnce right>
                  <p>
                    例えば、
                    <br />
                    書類作成の自動化 / 商品・予約管理システム
                    <br />
                    メールやカレンダーの同期 / データツールの作成等
                    <br />
                    あらゆる業務をサポート致します。
                  </p>
                </Reveal>
              </div>
              <div className="col-md-4 order-md-0">
                <Fade triggerOnce direction="left">
                  <img
                    className="float-start"
                    src={data}
                    alt="data"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </Fade>
              </div>
            </div>
            <div className="row align-items-center justify-content-center">
              <div className="col-md-4">
                <Reveal triggerOnce>
                  <p>
                    その他、
                    <br />
                    WebデザインやHTML/CSS/Java Scriptといった
                    <br />
                    フロントエンド開発も行っております。
                  </p>
                </Reveal>
              </div>
              <div className="col-md-4">
                <Fade triggerOnce>
                  <img
                    className="float-end"
                    src={website}
                    alt="website"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </Fade>
              </div>
            </div>
            <div className="row align-items-center justify-content-center pt-5">
              <Fade
                triggerOnce
                bottom
                className="row align-items-center justify-content-center"
              >
                <img
                  className="col-md-4"
                  src={googleIcons}
                  alt="googleicons"
                  style={{ maxWidth: "70vw" }}
                />
                <img
                  className="col-md-4"
                  src={webIcons}
                  alt="webicons"
                  style={{ maxWidth: "70vw" }}
                />
              </Fade>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
